<template>
    <div class="form-post-creator hide-scrollbar" ref="scrollableDiv">
      
        <section class="publish-date" v-if="isPrenium">
            <label>{{ $t('dash.post-creator.form.publish-date') }} <span v-if="updateFormData.planifiedDate" @click="$emit('restoreFormData','planifiedDate')" class="restore">{{ $t('dash.post-creator.form.cancel-changes') }}</span></label>
            <div class="content-section">
                <SelectComponent :changeValueSelect="changeSelectPublishDate" :data="{now:$t('dash.post-creator.form.now'),flanified:$t('dash.button.schedule')}" :valueSelect="!formData.planifiedDate.date ? 'now' : 'flanified'" :positionAuto="false" :positionX="'left'"></SelectComponent>
                <template v-if="formData.planifiedDate.date !== false && formData.planifiedDate.hours !== false">
                    <div class="input-date">        
                        <p>{{ formatInputDatePicker }}</p>
                        <i class="fa-regular fa-calendar"></i>
                        <input type="date" v-model="formData.planifiedDate.date" :disabled="formData.planifiedDate.date ? false : true" @click="(e)=>e.target.showPicker()" :min="new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')">
                
                    </div>
                    <div class="input-hours">
                        <!-- <input type="text" v-model="formData.planifiedDate.hours" @blur="comptetePlanifiedDateHours()"> -->
                        <VueTimepicker v-model="formData.planifiedDate.hours" manual-input @close="checkValidDate()"/>
                        <i class="fa-regular fa-clock"></i>
                        
                    </div>
                </template>
            </div>
        </section>
        <section class="content-post">
            <label>
                {{ $t('dash.post-creator.form.content') }}
                <Tooltip
                    v-if="mentionsWarningTextContent"
                    :active="true"
                    :text="mentionsWarningTextContent"
                    position="right"
                    classCustom="warning-tooltip">
                    <i class="fa-solid fa-circle-exclamation warning-icon"></i>
                </Tooltip>
                <span v-if="updateFormData.textContent" @click="$emit('restoreFormData','textContent')" class="restore">{{ $t('dash.post-creator.form.cancel-changes') }}</span>
            </label>
            <Editor
                :id="'contentPost'"
                @setMention="(id,mention)=>{
                    $set(this.formData.mentions, id, mention)
                    $emit('saveFormData')
                }"
                @setText="(text)=> {
                    $set(this.formData, 'textContent', text)
                    $emit('saveFormData')
                }"
                @apply-template="applyMessageTemplate"
                :mentions="this.formData.mentions"
                :text="this.formData.textContent"
                :maxCharacters="maxCharactersText"
                :textInfoMaxCharacters="textInfoMaxCharacters"
                :pickerStyle="'transform: translate(100%, -50%)'"
                :typeRenderNetworkSelected="typeRenderNetworkSelected"
                :personalizationMode="personalizationMode"
                :templateSaveData="formData.textContent ? { data: { text: formData.textContent }, source: 'post-message' } : null"
            />
        </section>
        <section class="content-media" v-if="!(personalizationMode && typeRenderNetworkSelected && (!acceptedFileTypesPerNetwork[typeRenderNetworkSelected] || acceptedFileTypesPerNetwork[typeRenderNetworkSelected].length == 0))">
            <label>
                {{ $t('dash.post-creator.form.media') }}
                <i class="fa-solid fa-circle-question" @click="showTableMedia"></i>
                <span v-if="updateFormData.files" @click="$emit('restoreFormData','files')" class="restore">{{ $t('dash.post-creator.form.cancel-changes') }}</span>
                <div class="template-trigger-wrapper" v-if="templatesFeatureEnabled">
                    <TemplateTrigger :open="showMediaTemplatePicker" @open="action => { mediaTemplateAction = action; showMediaTemplatePicker = true }">
                        <span class="template-trigger">{{ $t('dash.templates.apply-text') }}</span>
                    </TemplateTrigger>
                    <TemplatePicker
                        v-if="showMediaTemplatePicker"
                        :action="mediaTemplateAction"
                        type="media"
                        :save-data="mediaSaveData"
                        @apply="applyMediaTemplate"
                        @saved="showMediaTemplatePicker = false"
                        @close="showMediaTemplatePicker = false"
                    />
                </div>
            </label>
            <div class="container-medias" :class="{'wrap': true}">
                <input
                    v-validate="''"
                    name="file"
                    type="file"
                    id="file"
                    ref="inputMediaPostCreator"
                    @change="selectFiles"
                    :multiple="true"
                    @click="()=>{}"
                    :accept="this.acceptedFileTypesPerNetwork[this.personalizationMode && this.typeRenderNetworkSelected ? this.typeRenderNetworkSelected : 'default'].join(', ')" 
                    hidden
                >
                <DropFile v-if="!thumbnailSelector.fileIdVideo" :targetInput="$refs.inputMediaPostCreator"/>

                <div class="btn-add-media" @click="clickBtnAddMedia">
                    <i class="fa-solid fa-photo-film"></i>
                    <!-- <ContextMenu :options="[{label:'Ajouter une url',name:'link'},{label:'Importer des fichiers',name:'file'}]" :id="'btnAddMediaPostCreator'" v-on:clickOption="clickBtnAddMedia">
                        <i class="fa-solid fa-photo-film"></i>
                    </ContextMenu> -->
                </div>

                <draggable class="list-media hide-scrollbar" ref="listMedia" v-model="formData.files" v-bind="dragOptions" @start="drag=true" @end="endMoveFileMedia" :move="moveFileMedia">
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        
                        <template  v-for="media in formData.files" v-if="files[media.id] && (!personalizationMode || !typeRenderNetworkSelected || acceptedFileTypesPerNetwork[typeRenderNetworkSelected].includes(files[media.id].info.type))">                        
                            <Tooltip
                                :active="
                                        (!files[media.id] || (!files[media.id].isUpload && !files[media.id].uploadProgress)) ||
                                        (!personalizationMode && !files[media.id].uploadProgress && Object.keys(files[media.id].errorNetwork).length && Object.keys(files[media.id].errorNetwork).some(networkName => networksSelected.includes(networkName))) ||
                                        (personalizationMode && !files[media.id].uploadProgress && typeRenderNetworkSelected && files[media.id].errorNetwork.hasOwnProperty(typeRenderNetworkSelected))
                                " 
                                :text="
                                    (!files[media.id] || (!files[media.id].isUpload && !files[media.id].uploadProgress)) ?
                                        'Echec du chargement du media'
                                    : 
                                        (personalizationMode && typeRenderNetworkSelected && !files[media.id].uploadProgress && files[media.id].errorNetwork[typeRenderNetworkSelected]) ?
                                            `<b>${typeRenderNetworkSelected.charAt(0).toUpperCase() + typeRenderNetworkSelected.slice(1)} :</b><br>${Object.values(files[media.id].errorNetwork[typeRenderNetworkSelected]).join('<br>')}`
                                        :
                                            (!personalizationMode && !files[media.id].uploadProgress && Object.keys(files[media.id].errorNetwork).length && Object.keys(files[media.id].errorNetwork).some(networkName => networksSelected.includes(networkName))) ?
                                                Object.keys(files[media.id].errorNetwork).reduce((newArray, networkName) => {
                                                    if (networksSelected.includes(networkName))
                                                        newArray.push(`<b>${networkName.charAt(0).toUpperCase() + networkName.slice(1)} :</b><br>${Object.values(files[media.id].errorNetwork[networkName]).join('<br>')}`)
                                                        return newArray
                                                    },[]).join('<br><br>')
                                            : ''
                                " 
                            
                                position="bottom"
                                :key="media.id" 
                                classCustom="item-draggable"
                            >
                            
                                <i v-if="!files[media.id].isUpload && !files[media.id].uploadProgress" class="fa-solid fa-rotate-right" @click.stop="retryFile(media.id)"></i>
                                <i class="fa-solid fa-circle-xmark" @click="removeFile(media.id)"></i>
                                <div 
                                    v-if="files[media.id].info.type2 == 'image'" 
                                    class="media-container picture" 
                                    :class="files[media.id].info.type" 
                                    :key="`image${media.id}`" 
                                    @click="startEditMedia(media.id)"
                                >
                                    <div class="media picture" :media="media.id">
                                        <img draggable="false" :src="files[media.id].url" alt="" class="source">
                                    </div>
                                </div>
                                <div class="media-container video" :class="{ 'video-editable': mediaEditorEnabled }" v-else-if="files[media.id].info.type.startsWith('video/')" :key="`video${media.id}`">
                                    <div class="media video" :media="media.id">
                                        <!--  @mouseover="playVideoMedia" @mouseup="playVideoMedia" @mouseleave="pauseVideoMedia" @mousedown="pauseVideoMedia" -->
                                        <video muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true" :key="files[media.id].url" :src="files[media.id].url" :type="files[media.id].info.type"></video>

                                        <Tooltip
                                            v-if="mediaEditorEnabled"
                                            :active="isMediaLoading(media.id)"
                                            :text="$t('dash.post-creator.thumbnail.loading')"
                                            position="bottom"
                                            :classCustom="'video-edit-btn' + (isMediaLoading(media.id) ? ' disabled' : '')"
                                            @click.stop="!isMediaLoading(media.id) && $emit('start-edit-video', media.id)"
                                        >
                                            <i class="fa-solid fa-pen"></i>
                                        </Tooltip>

                                        <Tooltip
                                        :active="true"
                                        :text="$t('dash.post-creator.thumbnail.add')"
                                        position="bottom"
                                        classCustom="preview"
                                        :key="`thumbnail-${media.id}`"
                                        >
                                            <img v-if="media.imagePreview && media.imagePreview.id && files[media.imagePreview.id]" :type="files[media.imagePreview.id].info.type" :src="files[media.imagePreview.id].url" alt="" class="preview" draggable="false" @click.stop="clickBtnAddVideoPreview(media.id)">
                                            <video
                                                v-else
                                                muted
                                                playsinline
                                                preload="metadata"
                                                class="preview"
                                                @click.stop="clickBtnAddVideoPreview(media.id)"
                                                onloadedmetadata="this.muted = true"
                                                :key="files[media.id].url"
                                                :src="files[media.id].url"
                                                :type="files[media.id].info.type"
                                            >
                                            </video>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div class="media-container pdf" v-else-if="['application/pdf'].includes(files[media.id].info.type)" :key="`pdf${media.id}`">
                                    <div class="media pdf" :media="media.id">
                                        <div class="container-svg">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 36 44" fill="none"><path d="M4.31826 0H25.0017C25.2296 0.0296647 25.4589 0.0524506 25.6853 0.0904987C26.6275 0.249355 27.4586 0.654342 28.1394 1.31148C30.3569 3.45192 32.5639 5.60247 34.7602 7.76311C35.2913 8.28289 35.6901 8.88994 35.8815 9.61694C35.9883 10.0221 36.0002 10.4353 36 10.8519C35.9978 20.3622 35.996 29.8725 35.9946 39.3828C35.9974 39.7155 35.966 40.0475 35.9007 40.3738C35.6321 41.6494 34.9343 42.6408 33.8246 43.3332C33.1277 43.773 32.3182 44.0044 31.4927 43.9996C22.4808 43.9967 13.4688 43.9967 4.45688 43.9996C3.95217 43.9991 3.45185 43.9064 2.98092 43.7259C1.15872 43.0374 0 41.3676 0 39.4293C0 27.8178 0.00115338 16.2056 0.00346015 4.59286C0.00461999 4.29972 0.0317573 4.00724 0.0845573 3.71883C0.424084 1.84136 1.95498 0.357481 3.8399 0.0659931C3.99885 0.0414875 4.15866 0.0214961 4.31826 0ZM34.508 25.0961C34.508 20.3765 34.508 15.657 34.508 10.9374C34.508 10.7655 34.5067 10.5935 34.492 10.4226C34.4659 10.1189 34.4224 9.81836 34.2641 9.54751C34.102 9.26419 33.9023 9.00389 33.6702 8.77365C31.7438 6.89417 29.8174 5.01576 27.8911 3.13844C27.6007 2.85512 27.3187 2.56169 27.0123 2.29643C26.3395 1.71432 25.5344 1.48861 24.657 1.48861C17.9789 1.4876 11.3008 1.4876 4.62254 1.48861C3.77913 1.48861 3.03822 1.75645 2.42859 2.34222C1.77332 2.97034 1.49024 3.75215 1.49046 4.65069C1.4919 16.2241 1.49269 27.7974 1.49284 39.3706C1.49123 39.5459 1.50243 39.7212 1.52636 39.8949C1.67774 40.9205 2.21363 41.6847 3.12927 42.1795C3.61088 42.4398 4.13293 42.5303 4.67941 42.5301C13.5296 42.5275 22.3799 42.5269 31.2302 42.5282C31.331 42.5282 31.432 42.5282 31.533 42.5252C32.4668 42.4886 33.2371 42.1167 33.8283 41.3966C34.3078 40.813 34.5082 40.132 34.508 39.3837C34.5062 34.621 34.5058 29.8585 34.5069 25.0961H34.508Z" fill="#fff"></path><path d="M18.7277 11.049C18.7127 12.0105 18.5568 12.9146 18.3295 13.808C18.1805 14.3934 18.0268 14.9774 17.8719 15.5615C17.8626 15.5933 17.8602 15.6268 17.8648 15.6597C17.8694 15.6926 17.8809 15.7242 17.8985 15.7523C18.5004 16.8231 19.2651 17.7777 20.0347 18.7291C20.222 18.9606 20.4106 19.1913 20.597 19.4243C20.6349 19.4718 20.6703 19.486 20.7337 19.4778C21.3721 19.3955 22.0096 19.3059 22.6504 19.2414C23.497 19.1554 24.3463 19.1238 25.1938 19.2358C25.681 19.3003 26.1572 19.4078 26.588 19.6584C27.0839 19.946 27.3733 20.3596 27.3824 20.9467C27.3882 21.3336 27.2269 21.6311 26.9137 21.8495C26.6079 22.0645 26.2574 22.1539 25.8921 22.1909C24.919 22.2893 23.9962 22.0722 23.1024 21.7117C22.1762 21.337 21.3292 20.7923 20.6059 20.106C20.5282 20.0327 20.4619 20.0157 20.3587 20.0374C19.299 20.2594 18.2394 20.4757 17.2052 20.7958C16.6429 20.9699 16.0841 21.1584 15.5253 21.3448C15.4767 21.3648 15.4355 21.3994 15.4074 21.4437C14.9927 22.067 14.5908 22.7003 14.1657 23.317C13.5677 24.1842 12.9114 25.0045 12.1075 25.6969C11.5965 26.1369 11.0167 26.4374 10.3427 26.5419C10.0506 26.5908 9.75106 26.5724 9.46724 26.4882C9.00423 26.3476 8.56284 25.8407 8.62383 25.2878C8.6554 25.0017 8.78062 24.7549 8.94649 24.5256C9.25098 24.1045 9.645 23.7758 10.0622 23.4723C10.8269 22.9172 11.6649 22.4882 12.5109 22.0731C12.9849 21.8405 13.4589 21.6077 13.9304 21.3699C13.9862 21.3409 14.0315 21.2954 14.0601 21.2397C15.0296 19.1898 15.9146 17.1017 16.6948 14.9705C16.7168 14.9012 16.7168 14.8268 16.6948 14.7575C16.4909 14.1176 16.2517 13.4871 16.0787 12.8392C15.8438 11.9554 15.7439 11.0415 15.7822 10.1281C15.7899 9.88861 15.8224 9.65054 15.8791 9.41765C16.0804 8.62229 16.8538 8.26589 17.6031 8.61198C18.1319 8.85617 18.4217 9.29211 18.5776 9.83167C18.6959 10.2412 18.7186 10.6621 18.7277 11.049ZM17.5832 16.1831C17.0742 17.748 16.444 19.2399 15.7855 20.7403C17.2128 20.239 18.6688 19.8751 20.1881 19.6036C19.2251 18.5157 18.3509 17.4041 17.5832 16.1831ZM21.0079 19.8914C21.0451 19.9213 21.0609 19.9344 21.0775 19.9473C22.0291 20.652 23.1 21.1161 24.2237 21.4701C24.5161 21.5623 24.8138 21.6296 25.124 21.6165C25.5712 21.5978 25.9483 21.2994 26.0348 20.8964C26.1183 20.5094 25.9124 20.1057 25.5067 19.9136C25.31 19.8186 25.1024 19.7477 24.8885 19.7023C24.3595 19.5948 23.8193 19.6019 23.2853 19.6378C22.6292 19.6818 21.9763 19.7704 21.3221 19.8413C21.2242 19.8517 21.1281 19.8721 21.0079 19.8914ZM13.4959 22.1195L13.4758 22.1008C13.3158 22.181 13.1553 22.2605 12.9955 22.3409C12.223 22.7304 11.4374 23.0959 10.7051 23.56C10.2306 23.8609 9.77281 24.1833 9.39847 24.6068C9.2553 24.7691 9.1316 24.9445 9.06802 25.1545C8.91664 25.6556 9.34484 26.1126 9.85521 25.983C10.3076 25.8682 10.691 25.6225 11.0254 25.3035C11.8165 24.5486 12.4719 23.684 13.0749 22.7777C13.2191 22.561 13.3558 22.3394 13.4959 22.1195ZM16.9487 14.1055C16.9658 14.0937 16.9747 14.0911 16.9768 14.0858C16.9846 14.066 16.9905 14.0451 16.9967 14.0247C17.3354 12.9297 17.6059 11.8192 17.7091 10.6756C17.7372 10.3646 17.7193 10.0466 17.6918 9.73429C17.679 9.58768 17.6289 9.41787 17.5356 9.30931C17.1784 8.89293 16.7095 8.90991 16.4375 9.41679C16.4241 9.44216 16.4105 9.46731 16.399 9.49353C16.2861 9.74912 16.2374 10.0189 16.2232 10.2956C16.1951 10.8315 16.2772 11.3583 16.3529 11.8863C16.4611 12.6483 16.7102 13.3706 16.9487 14.1055Z" fill="#fff"></path><path d="M15.7803 37.7018V30.9759C15.8058 30.9716 15.8316 30.9687 15.8575 30.9673C16.4732 30.972 17.0902 30.9608 17.7041 30.9871C18.3109 31.0131 18.8829 31.17 19.365 31.5657C19.794 31.9176 20.057 32.3776 20.2106 32.8985C20.536 34.0053 20.4904 35.1014 20.0239 36.1595C19.7229 36.8422 19.2253 37.3437 18.4846 37.5653C18.1697 37.6562 17.8435 37.7026 17.5155 37.7029C16.961 37.7087 16.4063 37.7052 15.8519 37.7057C15.8304 37.7061 15.8099 37.7042 15.7803 37.7018ZM16.9014 36.8043C17.1438 36.8043 17.3752 36.8196 17.6038 36.8013C18.1745 36.7555 18.6156 36.4963 18.8812 35.9782C18.9428 35.8612 18.995 35.7395 19.0374 35.6143C19.28 34.8675 19.2785 34.1096 19.1297 33.3465C19.0583 32.981 18.9197 32.6397 18.6608 32.3605C18.1771 31.8381 17.5447 31.8398 16.9014 31.8682V36.8043Z" fill="#fff"></path><path d="M11.8611 35.0744V37.701H10.7495C10.7478 37.6638 10.7446 37.6264 10.7446 37.5888C10.7446 35.4228 10.7438 33.2569 10.7422 31.0909C10.7422 30.9923 10.7686 30.9643 10.8683 30.9656C11.5343 30.9749 12.2009 30.9656 12.8663 30.9888C13.15 31.0017 13.4314 31.0458 13.7054 31.1204C14.1967 31.2494 14.5137 31.5976 14.7088 32.0432C15.0021 32.713 14.9986 33.3975 14.6902 34.0613C14.4179 34.6477 13.9257 34.9544 13.2906 35.0163C12.8652 35.0578 12.4357 35.0568 12.0082 35.0742C11.9625 35.0759 11.9169 35.0744 11.8611 35.0744ZM11.8695 34.184C12.291 34.1769 12.7086 34.2186 13.1154 34.0948C13.3349 34.0282 13.5153 33.9044 13.605 33.6896C13.7914 33.2442 13.8038 32.7906 13.6007 32.3485C13.4861 32.0991 13.3014 31.8953 13.0069 31.8728C12.6349 31.8444 12.2608 31.8467 11.8875 31.8364C11.8819 31.8364 11.876 31.8442 11.8695 31.8489V34.184Z" fill="#fff"></path><path d="M24.7185 33.8796V34.761H22.6149V37.6978H21.501V30.9727C21.5421 30.971 21.5771 30.968 21.6124 30.968C22.7862 30.968 23.9601 30.9673 25.1341 30.9658C25.2263 30.9658 25.2598 30.9852 25.2572 31.0836C25.25 31.3371 25.2548 31.5909 25.2548 31.8575H22.6164C22.6138 31.9026 22.6102 31.9366 22.6102 31.9708C22.6102 32.5686 22.6121 33.1664 22.6078 33.7642C22.6078 33.8609 22.6368 33.8833 22.7302 33.8826C23.3459 33.8785 23.9616 33.8807 24.5775 33.8807L24.7185 33.8796Z" fill="#fff"></path></svg>
                                        </div>
                                        <!-- <pdf  :src="files[media.id].url" :page="1"></pdf> -->
                                        <img v-if="files[media.id].info.enclosure" draggable="false" :src="files[media.id].info.enclosure" alt="" class="source">
                                    </div>
                                </div>
                                <div v-if="files[media.id] && (!files[media.id].isUpload && files[media.id].uploadProgress || files[media.id].isNormalizing)" class="containerProgressBar">
                                    <div class="progressBar">
                                        <div v-if="files[media.id].isNormalizing" class="bar normalizing-bar"></div>
                                        <div v-else class="bar" :style="{width: `${parseInt(files[media.id].percentUpload)}%`}"></div>
                                    </div>
                                </div>
                                <!-- Video export (see MediaEditor.vue's finish()) runs in the background after the
                                     popup itself has already closed - this is the only feedback left that it's still
                                     happening, right on the original video's own thumbnail. Matched by fileIdOrigin
                                     (stable identity, see matchesVideoOrigin), not the transient fileId the session
                                     captured when it started - a sibling scope inheriting the same base video can
                                     conclude first and replace that id in the shared array this scope still reads
                                     from, which would otherwise make this match fail and hide the bar mid-export. -->
                                <div v-if="mediaEditorData.exporting && matchesVideoOrigin(media, mediaEditorData.fileIdOrigin)" class="containerProgressBar">
                                    <div class="progressBar">
                                        <div class="bar" :style="{width: `${Math.round(mediaEditorData.exportProgress * 100)}%`}"></div>
                                    </div>
                                </div>
                                <Tooltip
                                    v-if="media.mediaEditorData && media.mediaEditorData.exportError"
                                    :active="true"
                                    :text="media.mediaEditorData.exportError"
                                    position="bottom"
                                    classCustom="icon-normalized warning-icon-normalized"
                                >
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                </Tooltip>
                                <i class="fa-solid fa-circle-exclamation"></i>
                                <Tooltip
                                    v-if="files[media.id] && files[media.id].normalizedNetworks && files[media.id].normalizedNetworks.length > 0 && (
                                        (personalizationMode && typeRenderNetworkSelected && files[media.id].normalizedNetworks.includes(typeRenderNetworkSelected)) ||
                                        (!personalizationMode && files[media.id].normalizedNetworks.some(networkName => networksSelected.includes(networkName)))
                                    )"
                                    :active="true"
                                    :text="
                                        (personalizationMode && typeRenderNetworkSelected && files[media.id].normalizedNetworks.includes(typeRenderNetworkSelected)) ?
                                        `Image compressée pour <b>${typeRenderNetworkSelected.charAt(0).toUpperCase() + typeRenderNetworkSelected.slice(1)}</b>`
                                        :
                                        (!personalizationMode) ?
                                            `Image compressée pour <b>${files[media.id].normalizedNetworks.filter(networkName => networksSelected.includes(networkName)).map(n => n.charAt(0).toUpperCase() + n.slice(1)).join(', ')}</b>`
                                        : ''
                                    "
                                    position="bottom"
                                    classCustom="icon-normalized warning-icon-normalized"
                                    >
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                    </Tooltip>
                                    <Tooltip
                                        v-if="files[media.id].info.type.startsWith('image/')"
                                        :active="true"
                                        :text="$t('dash.post-creator.alt-text.add')"
                                        position="bottom"
                                        classCustom="alt-text-btn"
                                        :key="`alt-text-${media.id}`"
                                    >
                                        <span @click="addMode('inputMode', {
                                            id: `alt_text-${media.id}`,
                                            title: $t('dash.post-creator.alt-text.add'),
                                            value:  media.altTextValue,
                                            placeholder: $t('dash.post-creator.form.alt-text.placeholder')
                                        })">ALT</span>

                                    </Tooltip>

                                    <Tooltip
                                        v-if="files[media.id].info.type2 == 'pdf'"
                                        :text="$t('dash.post-creator.form.pdf-title.edit')"
                                        classCustom="title-pdf-btn"
                                        :key="`title-pdf-${media.id}`"
                                    >
                                        <span @click="addMode('inputMode', {
                                            id: `pdf_title-${media.id}`,
                                            title: $t('dash.post-creator.form.pdf-title.edit'),
                                            value:  files[media.id].info.customName,
                                            placeholder: files[media.id].info.name
                                        })">{{ $t('dash.post-creator.form.pdf-title.label') }}</span>
                                    </Tooltip>

                            </Tooltip>
                        </template>
                    </transition-group>
                </draggable>
            
            </div>
        </section>
        <section class="comment-post" :class="{disabled: typeRenderNetworkSelected === 'tiktok'}">
            <label>
                {{ $t('dash.post-creator.form.comment.label') }}
                <Tooltip
                    v-if="typeRenderNetworkSelected === 'tiktok'"
                    :active="true"
                    :text="$t('dash.post-creator.form.comment.tiktok-warning')"
                    position="right"
                    classCustom="warning-tooltip">
                    <i class="fa-solid fa-circle-exclamation warning-icon"></i>
                </Tooltip>
                <Tooltip
                    v-if="mentionsWarningComments"
                    :active="true"
                    :text="mentionsWarningComments"
                    position="right"
                    classCustom="warning-tooltip">
                    <i class="fa-solid fa-circle-exclamation warning-icon"></i>
                </Tooltip>
                <span v-if="updateFormData.comments && updateFormData.comments.length" @click="$emit('restoreFormData','comments')" class="restore">{{ $t('dash.post-creator.form.cancel-changes') }}</span>
            </label>
            <!-- <Textarea v-on:setTextareaValue="setTextareaCommentValue" :showOptionBold="false" :showOptionItalic="false" :showOptionUnderline="false" :ShowCounterCharacters="false"></Textarea> -->
            <div class="list-comment">
                <div class="comment-row" v-for="(comment, index) in formData.comments" :key="index">
                    <Editor
                        :id="'contentCommentPost'"
                        @setMention="(id,mention)=>{
                            $set(formData.mentions, id, mention)
                            $emit('saveFormData')
                        }"
                        @setText="(text)=> {
                            $set(formData.comments, index, text)
                            $emit('saveFormData')
                        }"
                        @onBlur="clearComment"
                        @apply-template="template => applyCommentTemplate(template, index)"
                        :mentions="formData.mentions"
                        :text="comment"

                        :compactOption="true"
                        :showOptionBold="false"
                        :showOptionItalic="false"
                        :showOptionUnderline="false"
                        :ShowCounterCharacters="false"
                        :pickerStyle="'transform: translate(0%, -50%)'"
                        :typeRenderNetworkSelected="typeRenderNetworkSelected"
                        :personalizationMode="personalizationMode"
                        :templateSaveData="comment ? { data: { text: comment }, source: 'post-comment' } : null"
                    />
                </div>
            </div>
            
            <p v-if="formData.comments && formData.comments[0]" class="btn-add-comment" @click="newComment">{{ $t('dash.post-creator.form.comment.add') }}</p>
        </section>

        <section class="settings-advanced">
            <label :class="{big: !personalizationMode || idPageRenderNetworkSelected}">{{ $t('dash.post-creator.form.settings.label') }} {{ typeRenderNetworkSelected || networkSetting }} <span v-if="updateFormData.formDataNetwork && updateFormData.formDataNetwork[typeRenderNetworkSelected]" @click="$emit('restoreFormData','formDataNetwork')" class="restore">{{ $t('dash.post-creator.form.cancel-changes') }}</span></label>

            <p v-show="!personalizationMode || idPageRenderNetworkSelected" class="sub-label">{{ $t('dash.post-creator.form.settings.subtitle') }}</p>
            <div class="nav-network hide-scrollbar" v-if="false">
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'instagram'}" @click="networkSetting = 'instagram'">
                    <i class="fa-brands fa-instagram"></i>Instagram
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'facebook'}" @click="networkSetting = 'facebook'">
                    <i class="fa-brands fa-facebook"></i>Facebook
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'linkedin'}" @click="networkSetting = 'linkedin'">
                    <i class="fa-brands fa-linkedin"></i>Linkedin
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'threads'}" @click="networkSetting = 'threads'">
                    <svg :style="{height: '15px'}" aria-label="Threads" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path class="x19hqcy" d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"/></svg>Threads
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'twitter'}" @click="networkSetting = 'twitter'">
                    <i class="fa-brands fa-twitter" style="font-size: 14px;"></i>Twitter
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'tiktok'}" @click="networkSetting = 'tiktok'">
                    <i class="fa-brands fa-tiktok"></i>Tiktok
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'google'}" @click="networkSetting = 'google'">
                    <i class="fa-brands fa-google"></i>My Business
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'pinterest'}" @click="networkSetting = 'pinterest'">
                    <i class="fa-brands fa-pinterest"></i>Pinterest
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'youtube'}" @click="networkSetting = 'youtube'">
                    <i class="fa-brands fa-youtube"></i>Youtube
                </div>
            </div>

            <component
                v-for="network in ['instagram', 'facebook', 'linkedin', 'threads', 'twitter', 'tiktok', 'google', 'pinterest', 'youtube']"
                :is="`Form${network.charAt(0).toUpperCase()}${network.slice(1)}`"
                v-show="(!personalizationMode && typeRenderNetworkSelected == network) || (personalizationMode && typeRenderNetworkSelected == network)"
                ref="formNetwork"
                :key="network"
                :formData="formData"
                :formDataNetwork="formData.formDataNetwork[network]"
                :files="files"
                :personalizationMode="personalizationMode"
                :idPageRenderNetworkSelected="idPageRenderNetworkSelected"
                :typeRenderNetworkSelected="typeRenderNetworkSelected"
                :maxCharactersText="maxCharactersText"
                @setFormDataNetwork="setFormDataNetwork"

            />
        </section>
        <portal to="dash" v-if="imageCropperData.fileIdOrigin && files[imageCropperData.fileIdOrigin] && files[imageCropperData.fileIdOrigin].url">
            <transition name="fade">
                    <ImageCropper
                        key="image-cropper"
                        :src="files[imageCropperData.fileIdOrigin].url"
                        :imageState="JSON.parse(imageCropperData.imageState)"
                        :mediaEditorEnabled="mediaEditorEnabled"
                        @finished="endEditImage"
                        @convert-to-video="convertImageToVideo"
                        @clickOutside="imageCropperData.fileIdOrigin = null"

                    />
            </transition>
        </portal>
        <portal to="dash" v-if="thumbnailSelector.fileIdVideo && files[thumbnailSelector.fileIdVideo] && files[thumbnailSelector.fileIdVideo].url">
            <transition name="fade">
                <ThumbnailSelector
                    key="thumbnail-selector"
                    :videoSrc="files[thumbnailSelector.fileIdVideo].url"
                    :videoType="files[thumbnailSelector.fileIdVideo].info.type"
                    :localFile="files[thumbnailSelector.fileIdVideo].localFile"
                    :initialTimestampMs="(formData.formDataNetwork.tiktok && formData.formDataNetwork.tiktok.video_cover_timestamp_ms) || 0"
                    @confirmUpload="onThumbnailUpload"
                    @confirmFrame="onThumbnailFrame"
                    @clickOutside="thumbnailSelector.fileIdVideo = null"
                />
            </transition>
        </portal>
    </div>
</template>

<script>

import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import SelectComponent from '@/components/dash/utils/select.vue'
import Editor from './Editor.vue'
import ComponentSwitch from '@/components/dash/utils/switch.vue'
import Checkbox from '@/components/dash/utils/checkbox.vue'
import SnippetNetwork from './SnippetNetwork.vue'
import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
import draggable from 'vuedraggable'
import minxinBot from '@/components/mixins/Bots.vue'
import minxinPosts from '@/components/mixins/Posts.vue'
import minxinNotification from '@/components/mixins/Notif.vue'
import DropFile from '@/components/dash/DropFile.vue'
import {maxCharactersByNetworkForText, acceptedFileTypesPerNetwork, maxMentionsSafeByNetwork} from '@/components/dash/postCreator/constante.js'
import { matchesVideoOrigin, getValidPlanifiedDateTime } from '../../utils.js'

import FormInstagram from './formNetwork/formInstagram.vue'
import FormFacebook from './formNetwork/formFacebook.vue'
import FormLinkedin from './formNetwork/formLinkedin.vue'
import FormThreads from './formNetwork/formThreads.vue'
import FormTwitter from './formNetwork/formTwitter.vue'
import FormTiktok from './formNetwork/formTiktok.vue'
import FormGoogle from './formNetwork/formGoogle.vue'
import FormPinterest from './formNetwork/formPinterest.vue'
import FormYoutube from './formNetwork/formYoutube.vue'
import pdf from 'pdfvuer'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import ImageCropper from '@/components/dash/ImageCropper.vue';
import ThumbnailSelector from './ThumbnailSelector.vue';
import TemplatePicker from '@/components/dash/shared/TemplatePicker.vue';
import TemplateTrigger from '@/components/dash/shared/TemplateTrigger.vue';
import TemplatesFeatureFlag from '@/components/mixins/TemplatesFeatureFlag.vue';



export default {
    mixins: [minxinBot, minxinPosts, minxinNotification, TemplatesFeatureFlag],
    components: {
        Editor,
        SelectComponent,
        ComponentSwitch,
        SnippetNetwork,
        Checkbox,
        Tooltip,
        ContextMenu,
        draggable,
        pdf,
        VueTimepicker,
        FormInstagram,
        FormFacebook,
        FormLinkedin,
        FormThreads,
        FormTwitter,
        FormTiktok,
        FormGoogle,
        FormPinterest,
        FormYoutube,
        DropFile,
        ImageCropper,
        ThumbnailSelector,
        TemplateTrigger,
        TemplatePicker
    },
    props: {
        typeRenderNetworkSelected: {
            type: String,
            default: 'facebook'
        },

    
        formData :  Object,
        
        updateFormData : {
            type: Object,
            default: () => ({})
        },

        personalizationMode : {
            type: Boolean,
            default: false
        },

        networksSelected : {
            type: Array,
            default: () => ([])
        },

        idPageRenderNetworkSelected: String,
        files:Object,

        // Owned by StandardTab.vue now, not this component - a background video export must
        // survive switching between standard/personalization mode, which destroys/recreates
        // whichever Form instance is active (see StandardTab.vue's `formShow`). Read-only here:
        // this component only ever reads it for the progress bar/error icon on a media thumbnail,
        // and emits start-edit-video/convert-image-to-video for the parent to act on instead of
        // mutating it directly.
        mediaEditorData: {
            type: Object,
            default: () => ({ fileIdOrigin: null, fileId: null, exporting: false, exportProgress: 0 })
        },
        mediaEditorEnabled: {
            type: Boolean,
            default: false
        },

        // { [pageId]: { count, comments: [{index, count}] } } - calculé par StandardTab.vue, qui
        // seul connait saveAllFormData et donc les personnalisations des pages non affichées.
        // Filtré ici sur targetPages pour ne parler que du périmètre à l'écran.
        mentionsOverSafeLimitByPage: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            lastModeSelected : undefined,
            networkSetting: 'instagram',
            drag : false,
            timeoutVerifMetaUrl: null,
            acceptedFileTypesPerNetwork: acceptedFileTypesPerNetwork,


            imageCropperData: {
                fileIdOrigin: null,
                fileId: null,
                imageState: null
            },

            thumbnailSelector: {
                fileIdVideo: null
            },

            showMediaTemplatePicker: false,
            mediaTemplateAction: 'apply',
        }
    },

    created () {
        console.log('created form formdata ', this.formData)
    },

    mounted () {
        console.log('mounted form formdata ', this.formData)
        EventBus.$on("eventCloseInput", this.resultInputMode)
    },

    methods: {

        // only 'affix' templates reach here (wraps the current value) - 'text' ones are inserted
        // at the cursor by Textarea.vue; the text branch is just a fallback
        applyMessageTemplate(template) {
            const current = this.formData.textContent || ''
            const next = template.type === 'affix'
                ? `${template.data.prefix || ''}${current}${template.data.suffix || ''}`
                : (template.data.text || '')

            this.$set(this.formData, 'textContent', next)
            this.$emit('saveFormData')
        },

        applyCommentTemplate(template, index) {
            const current = this.formData.comments[index] || ''
            const next = template.type === 'affix'
                ? `${template.data.prefix || ''}${current}${template.data.suffix || ''}`
                : (template.data.text || '')

            this.$set(this.formData.comments, index, next)
            this.$emit('saveFormData')
        },

        // Exposed as a method (not just imported) so the template can call it directly - see the
        // export progress bar's v-if above.
        matchesVideoOrigin,

        addMode(mode, data = {}) {
            this.lastModeSelected = mode
            EventBus.$emit("postCreatorAddMode", mode, data);
        },
            
        changeSelectPublishDate(value) {
            if (!this.date && value == "flanified") {
                let date = new Date((new Date).getTime() + 3600000)
                this.$set(this.formData.planifiedDate, 'date', date.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-'));
                this.$set(this.formData.planifiedDate, 'hours', date.toLocaleString('fr-FR').split(' ')[1].split(':').slice(0,2).join(':'));
            }else if(value == "now") {
                this.$set(this.formData.planifiedDate, 'date',false)
                this.$set(this.formData.planifiedDate, 'hours', false)
            }  
        
            this.$emit('saveFormData')
        },

        clickBtnAddMedia(id, value=null) {

            switch (value) {
                case 'link':
                    
                    break;
            
                case 'file':
                default:
                    this.$refs.inputMediaPostCreator.click()
                    break;
            }
        },

        // template files are already hosted on S3 (MediaTemplateUploader.vue) - going through
        // addFile/uploadFile would fetch() each one to re-upload it as if it were new, which is
        // both pointless and fails outright (fetch() to an S3 url is CORS-blocked here, unlike
        // an <img>/<video> tag pointed at the same url). addExistingFiles registers them as
        // already-uploaded directly instead.
        applyMediaTemplate(template) {
            this.showMediaTemplatePicker = false

            const templateFiles = template.data && Array.isArray(template.data.files) ? template.data.files : []
            if (!templateFiles.length) return

            const ids = templateFiles.map(() => Math.random().toString(36).substr(2, 9))

            this.$emit('addExistingFiles', templateFiles, ids, () => {
                this.$set(this.formData, 'files', [
                    ...this.formData.files,
                    ...ids.map((id) => ({ id }))
                ])
            })
        },

        async selectFiles(e) {
            const files = Array.from(e.target.files);
            const ids = files.map(()=>(Math.random().toString(36).substr(2, 9)))
            console.log('ids',ids)
     
            this.$emit('addFile',null, e.target.files, true, ids,(filesAdded)=>{
                this.$set(this.formData, 'files', [
                    ...this.formData.files, 
                    ...ids.map((id) => ({id}))
                ])
                this.notifyUploadFile(files)
            

                this.$refs.formNetwork.forEach(form => {
                    if (form && form.fileAdded && typeof form.fileAdded === 'function') form.fileAdded(ids)
                })

            })

            e.target.value = null;
        },

        notifyUploadFile(files) {

            if (this.personalizationMode) return

            const networksSelected = [...new Set(this.pagesSelected.map(page => page.network))]
            
            const networksNotCompatible = []

            files.forEach(f => {
                networksSelected.forEach(network => {
                    if (!acceptedFileTypesPerNetwork[network].includes(f.type)) {
                        if (!networksNotCompatible.includes(network)) networksNotCompatible.push(network)
                    }
                })
            });
            
            if (networksNotCompatible.length) {
                let text;
                if (files.length === 1) {
                    if (networksNotCompatible.length == networksSelected.length) {
                        text = `Le fichier que vous avez ajouté n'est pas compatible avec les réseaux sélectionnés.`
                    }else{
                        text =`
                            Le fichier que vous avez ajouté n'est pas compatible avec ${networksNotCompatible.length == 1 ? 'le réseau' : 'les réseaux :'} 
                            ${networksNotCompatible.map(n => '<b>' + n.charAt(0).toUpperCase() + n.slice(1) + '</b>').join(', ')}.
                        `
                    }
                }else{
                    text = `Certains fichiers que vous avez ajoutés ne sont pas compatibles avec les réseaux suivants : <b>${networksNotCompatible.map(n => n.charAt(0).toUpperCase() + n.slice(1)).join(', ')}</b>.`
                }
                this.notify({
                    title: 'Fichier non compatible',
                    text: text,
                    color: 'primary',
                    time: 0,
                    id: Date.now()
                })
                

            }
        },

        removeFile(id) {
            this.$set(this.formData, 'files', this.formData.files.filter(f =>(f.id !== id)))
            // les tags identifiés sont positionnés par idFile : sans ça ils deviennent orphelins (invisibles dans la modale d'édition, cf selectPerson.vue) si le fichier est retiré
            if (this.formData.formDataNetwork.instagram?.personsIdentified?.length) {
                this.$set(this.formData.formDataNetwork.instagram, 'personsIdentified', this.formData.formDataNetwork.instagram.personsIdentified.filter(p => p.idFile !== id))
            }
            // scopes qui héritent ce fichier de celui-ci (main ou réseau) sans avoir leur propre liste de fichiers : à nettoyer aussi côté PostCreator.vue
            this.$emit('personsIdentifiedRemoved', id)
            // purge le registre partagé si le fichier n'a jamais fini d'uploader (no-op sinon, cf PostCreator.vue)
            this.$emit('discardFailedFile', id)
            //this.$emit('saveFormData') dans le watch
            setTimeout(() => {

                this.$refs.formNetwork.forEach(form => {
                    if (form && form.fileAdded) form.fileAdded()
                })
            }, 10);
        },

        retryFile(id) {
            this.$emit('retryUploadFile', id)
        },

        isMediaLoading(id) {
            const file = this.files[id]
            if (!file) return false
            return (!file.isUpload && file.uploadProgress) || file.isNormalizing
        },

        clickBtnAddVideoPreview(id) {
            const files = this.formData.files
            const indexFile = files.findIndex(file => file.id === id)
            if (indexFile < 0) return

            if (files[indexFile].imagePreview && files[indexFile].imagePreview.id) {
                this.$delete(this.formData.files[indexFile], 'imagePreview')
                this.clearTiktokVideoCoverTimestamp()
            } else {
                this.thumbnailSelector.fileIdVideo = id
            }
        },

        onThumbnailUpload(file) {
            this.applyThumbnailFile(file)
            this.clearTiktokVideoCoverTimestamp()
            this.thumbnailSelector.fileIdVideo = null
        },

        onThumbnailFrame({ file, timestampMs }) {
            this.applyThumbnailFile(file)
            if (!this.formData.formDataNetwork.tiktok) {
                this.$set(this.formData.formDataNetwork, 'tiktok', {})
            }
            this.$set(this.formData.formDataNetwork.tiktok, 'video_cover_timestamp_ms', timestampMs)
            this.$emit('saveFormData')
            this.thumbnailSelector.fileIdVideo = null
        },

        applyThumbnailFile(file) {
            const idFile = this.thumbnailSelector.fileIdVideo
            if (!idFile) return
            const newFileId = Math.random().toString(36).substr(2, 9)
            this.$set(this.formData, 'files', this.formData.files.map((f) => {
                if (f.id !== idFile) return f
                f.imagePreview = { id: newFileId }
                this.$emit('addFile', null, file, true, newFileId)
                return f
            }))
        },

        clearTiktokVideoCoverTimestamp() {
            if (this.formData.formDataNetwork.tiktok && this.formData.formDataNetwork.tiktok.hasOwnProperty('video_cover_timestamp_ms')) {
                this.$delete(this.formData.formDataNetwork.tiktok, 'video_cover_timestamp_ms')
                this.$emit('saveFormData')
            }
        },
        endMoveFileMedia() {
            console.log('endMoveFile', this.$refs.formNetwork)
            this.drag=false
            setTimeout(() => {
             
                this.$refs.formNetwork.forEach(form => {
                    if (form && form.fileAdded) form.fileAdded()
                })
            }, 10);
            
        },
        moveFileMedia() {
            // console.log("moveFileMedia", this.formData.files[0])
            // this.$nextTick(() => {
            //     this.$emit('saveFormData')
            // })
            //this.$emit('setFormData', this.formData)
            // this.$refs.formNetwork.forEach(form => {
            //     if (form && form.fileAdded) form.fileAdded()
            // })
        },

        calculTimeStampPlanifiedDate() {
            let date = new Date(this.formData.planifiedDate.date)

            if (this.formData.planifiedDate.hours.includes(":")) {
                let [hours, minutes] = this.formData.planifiedDate.hours.split(':').map(value => isNaN(value) ? 0 : parseInt(value))
                date.setMinutes(minutes)
                date.setHours(hours)
            }

            this.$set(this.formData.planifiedDate, 'timestamp', date.getTime());
            this.$emit('saveFormData')
        },

        checkValidDate() {
            if (!this.formData.planifiedDate.date) return

            const { date, hours } = getValidPlanifiedDateTime(this.formData.planifiedDate.date, this.formData.planifiedDate.hours)

            this.$set(this.formData.planifiedDate, 'hours', hours)
            this.$set(this.formData.planifiedDate, 'date', date)
            this.calculTimeStampPlanifiedDate()
        },

        setFormDataNetwork(typeNetwork, data) {
            console.log('setFormDataNetwork',typeNetwork, this.personalizationMode)
            if (this.personalizationMode && typeNetwork !== this.typeRenderNetworkSelected) return
            this.$set(this.formData.formDataNetwork, typeNetwork, data);
            this.$emit('saveFormData')
        },

        playVideoMedia(e) {
            console.log(e)
        },

        getUrlsContent(content) { 
          try {
              const urls = this.unescapeSpecialChars(content).match(/(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:[\/?][^\s]*)?/g); // eslint-disable-line
              return urls ? [...new Set(urls.map(url => ((!/^https?:\/\//i.test(url) ? 'https://' + url  : url)).replaceAll("\\n",'')))] : []
          }catch (error) {
              return []
          }
        },

        unescapeSpecialChars(str) {
            // Remplacer les séquences échappées par leurs équivalents littéraux
            return str
                .replace(/\\n/g, '\n')          // Newline '\n'
                .replace(/\\t/g, '\t')          // Tab '\t'
                .replace(/\\r/g, '\r')          // Carriage return '\r'
                .replace(/\\f/g, '\f')          // Form feed '\f'
                .replace(/\\v/g, '\v')          // Vertical tab '\v'
                .replace(/&nbsp;/g, ' ')        // '&nbsp;' -> space ' '
                .replace(/\\\\/g, '\\');        // Backslash '\\'
        },

        newComment() {
            const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
            if (this.formData.comments[0] && !regex.test(this.formData.comments[0])) {
                this.clearComment()
                this.$set(this.formData.comments, this.formData.comments.length, '')
            }
        },

        clearComment() {

            //si il est question que de saut de ligne
            const array = []
            const regex = /^(<br\s*\/?>|\\n|\s*)+$/i

            for (let index = 0 ; index < this.formData.comments.length; index++) {
                const comment = this.formData.comments[index];
                if (comment.length && !regex.test(comment)) {
                    array.push(comment)
                } 
            }
            if (array.length === 0) {
                array.push("");
            }
            
            this.$set(this.formData, 'comments', array)
        },

        showTableMedia() {
            EventBus.$emit('showTable' , {
                title: 'Limites des médias',
                subTitle: 'Voici un aperçu des principales limites pour chaque type de média<br>sur les réseaux sociaux pris en charge :',
                tables : [
                    {
                        name: 'Image',
                        columns: [
                            { label: 'Réseau sociaux', key: 'network', dataColor: '#000', dataFontWeight: '600' },
                            { label: 'Nombre d’image', key: 'imagesAmmount'},
                            { label: 'Tailles', key: 'size'},
                            { label: 'Dimension max', key: 'dimensionMax'},
                            { label: 'Dimension min', key: 'dimensionMin'},
                            { label: 'Gif', key: 'gif'}
                        ],

                        data: [
                            { network: 'Facebook', imagesAmmount: '80 images', size: '< 4 Mo', dimensionMax: null, dimensionMin: null, gif: 'N/A' },
                            { network: 'Twitter', imagesAmmount: '4 images', size: '< 5 Mo', dimensionMax: '8192x8192', dimensionMin: '4x4', gif: '< 350 frames' },
                            { network: 'Linkedin', imagesAmmount: '20 images', size: null, dimensionMax: '36 152 320 pixels', dimensionMin: null, gif: '< 250 frames' },
                            { network: 'Instagram', imagesAmmount: '20 images', size: '< 8 Mo', dimensionMax: '1.91:1', dimensionMin: '4:5', gif: 'N/A' },
                            { network: 'Google Business Profile', imagesAmmount: '1 image', size: '< 5 Mo', dimensionMax: "2120x1192", dimensionMin: '250x250', gif: 'N/A' },
                            { network: 'Tiktok', imagesAmmount: '35 images', size: '< 20 Mo', dimensionMax: '1080x1080', dimensionMin: null, gif: 'N/A' },
                        ]
                    },

                    {
                        name: 'Video',
                        columns: [
                            { label: 'Réseau sociaux', key: 'network', dataColor: '#000', dataFontWeight: '600' },
                            { label: 'Durée', key: 'duration'},
                            { label: 'Taille', key: 'size'},
                        ],

                        data: [
                            { network: 'Facebook', duration: '20 minutes', size: '< 1 Go'},
                            { network: 'Facebook reel', duration: '20 secondes', size: '< 1 Go'},
                            { network: 'Twitter', duration: '140 secondes', size: '< 512 Mo'},
                            { network: 'Linkedin', duration: '30 minutes', size: '< 5 Go'},
                            { network: 'Linkedin conciergerie', duration: '30 minutes', size: '< 5 Go'},
                            { network: 'Instagram video', duration: '60 secondes', size: '< 1 Go'},
                            { network: 'Instagram reel', duration: '15 minutes', size: '< 1 Go'},
                            { network: 'Tiktok', duration: '3 minutes', size: '< 4 Go'},
                            { network: 'Bluesky', duration: '3 minutes', size: '< 100 Mo'},
                        ]
                    }
                ]
            })
        },
        
        resultInputMode(id, value) {
            const [primaryId, secondaryId] = id.split('-')

            let mediaId, indexFile
            switch (primaryId) {
                case 'alt_text' :
                    mediaId = secondaryId
                    indexFile = this.formData.files.findIndex(f => f.id == mediaId)
                    if(indexFile >= 0) {
                        this.formData.files[indexFile].altTextValue = value.trim()
                        this.$emit('saveFormData')
                    }
                    break;
                case 'pdf_title' : 
                    mediaId = secondaryId
                    this.$set(this.files[mediaId].info, 'customName', value.trim())
                    break;
                
            }
        },

        // Le mode photo de MediaEditor remplace ImageCropper comme point d'entrée par défaut ici -
        // ImageCropper.vue et son wiring (imageCropperData/endEditImage/convertImageToVideo,
        // ci-dessous) restent intacts et fonctionnels, toujours utilisés ailleurs (LocationEditor.vue).
        startEditMedia(fileId) {
            if (!this.files[fileId] || !this.files[fileId].url) return
            if (!this.files[fileId].isUpload) return
            if (this.files[fileId].info.type2 !== 'image') return

            // Un gif est animé - MediaEditor l'ouvre en mode vidéo (voir originIsGif dans
            // StandardTab.vue/MediaEditor.vue), pas en mode photo, même si type2 reste 'image'.
            this.$emit('start-edit-image', fileId)

            // Ancien déclencheur (ImageCropper) - conservé en commentaire, pas supprimé.
            // this.imageCropperData.imageState = null
            // this.imageCropperData.fileIdOrigin = null
            // this.imageCropperData.fileId = null
            // const media = this.formData.files.find(f => f.id === fileId)
            // if (media) {
            //     this.imageCropperData.fileId = fileId
            //     if (media.imageCropperData && media.imageCropperData.fileIdOrigin && this.files[media.imageCropperData.fileIdOrigin] && this.files[media.imageCropperData.fileIdOrigin].url) {
            //         if (media.imageCropperData.imageState) {
            //             this.imageCropperData.imageState = media.imageCropperData.imageState
            //         }
            //         this.imageCropperData.fileIdOrigin = media.imageCropperData.fileIdOrigin
            //     } else {
            //         this.imageCropperData.fileIdOrigin = fileId
            //     }
            // }
        },

        handleEditorLoad: function () {
            if (this.imageCropperData.imageState) {
                this.$refs.editor.editor.history.write(
                    JSON.parse(this.imageCropperData.imageState)
                );
            }  
        },

        endEditImage(event) {
            console.log('Image éditée :', event);

           
            
            const finalStateString = JSON.stringify(event.imageState, (k, v) => (v === undefined ? null : v));


            if (this.imageCropperData.imageState === finalStateString)  {
                console.log('Aucune modification de l\'image détectée, aucune action nécessaire.');
                this.imageCropperData.fileIdOrigin = null
                return;
            }

            //upload de la nouvelle image éditée

            const file = event.dest;
            const id = Math.random().toString(36).substr(2, 9)
            const oldFileId = this.imageCropperData.fileId

            this.$emit('addFile', null, file, true, id, (filesAdded)=>{
                const newFilesFormData = this.formData.files.map(f => {

                    if (f.id === oldFileId) {
                        return {
                            id, 
                            imagePreview: f.imagePreview,
                            imageCropperData: {
                                fileIdOrigin: this.imageCropperData.fileIdOrigin,
                                imageState: finalStateString
                            }
                        }
                    }
                    return f
                })
                this.$set(this.formData, 'files', newFilesFormData)

                // l'image éditée obtient un nouvel id de fichier : migrer ses tags identifiés vers ce nouvel id pour ne pas les orpheliner (cf removeFile)
                if (this.formData.formDataNetwork.instagram?.personsIdentified?.length) {
                    this.$set(this.formData.formDataNetwork.instagram, 'personsIdentified', this.formData.formDataNetwork.instagram.personsIdentified.map(p => p.idFile === oldFileId ? { ...p, idFile: id } : p))
                }
                // idem : migrer aussi pour les scopes qui héritent ce fichier sans liste de fichiers propre
                this.$emit('personsIdentifiedMigrated', { oldId: oldFileId, newId: id })
                this.notifyUploadFile([file])

                this.$refs.formNetwork.forEach(form => {
                    if (form && form.fileAdded) form.fileAdded()
                })
                this.imageCropperData.fileIdOrigin = null
            })

        },

        // Bridge from ImageCropper.vue's "Créer une vidéo" button - closes the image editor
        // without saving whatever crop was in progress (same silent-discard behavior as clicking
        // outside it), then hands off to whichever ancestor now owns the actual video-editing
        // session (see StandardTab.vue's onConvertImageToVideo) - moved up there so a background
        // export survives switching between standard/personalization mode, which used to destroy
        // this component (and the export running inside it) entirely.
        convertImageToVideo() {
            if (!this.mediaEditorEnabled) return
            if (this.mediaEditorData.exporting) return

            const fileId = this.imageCropperData.fileId
            const fileIdOrigin = this.imageCropperData.fileIdOrigin
            this.imageCropperData.fileIdOrigin = null
            this.$emit('convert-image-to-video', { fileId, fileIdOrigin })
        },

        // Called by StandardTab.vue (via a shared ref) right after it replaces a media's file
        // following a completed video export - these two are the only parts of the old
        // endEditMedia that only make sense against whichever Form instance is actually showing
        // right now (per-network UI refresh), as opposed to the state itself (formData/files),
        // which already lives above this component and needs no such relay.
        onMediaReplaced(files) {
            this.notifyUploadFile(files)
            this.$refs.formNetwork.forEach(form => {
                if (form && form.fileAdded) form.fileAdded()
            })
        },
    },

    computed: {
        console: () => console,

        // null (hides the "Enregistrer" action) while any attached media is still a local blob:
        // url (not yet uploaded) - a template can't reference it once this tab session ends
        mediaSaveData() {
            if (!this.formData.files || !this.formData.files.length) return null

            const templateFiles = []
            for (const media of this.formData.files) {
                const entry = this.files[media.id]
                if (!entry || !entry.url || entry.url.startsWith('blob:')) return null
                templateFiles.push({ url: entry.url, mimetype: entry.info && entry.info.type })
            }

            return { data: { files: templateFiles }, source: 'post-media' }
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },
        isPrenium() {
            return true
            // return this.currentUser?._premium?.plan > 1;
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        }, 

        targetPages() {
            if (!this.personalizationMode) return this.pagesSelected;
            if (this.idPageRenderNetworkSelected) return [this.allPages[this.idPageRenderNetworkSelected]];
            if (this.typeRenderNetworkSelected) return this.pagesSelected.filter(page => this.typeRenderNetworkSelected == page.network);
            return []
        },

        formatInputDatePicker() {
            if(this.formData.planifiedDate.date == false) return '';
            let dateNow = new Date()
            let dateFuture = new Date(this.formData.planifiedDate.date)
      
            if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                if (Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24)) < 7) {
                    if (dateFuture.getDay() === dateNow.getDay()) return this.$t('dash.post-creator.render.today')
                    if (dateFuture.getDay() === dateNow.getDay()+1) return this.$t('dash.post-creator.render.tomorrow')
                    return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long' });
                }
              
                if(dateFuture.getMonth() === dateNow.getMonth()) return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric'});

                return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric', month: 'numeric' });
            }
            return dateFuture.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'numeric', year: 'numeric' });
        },

        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },

        maxCharactersText() {
            return Math.min(...(this.targetPages.filter(page => !this.personalizationMode || page.network == this.typeRenderNetworkSelected).map(page => maxCharactersByNetworkForText[page.network] && maxCharactersByNetworkForText[page.network]({page}))))
        },

        textInfoMaxCharacters() {
            const maxCharactersByNetwork = {}

            this.targetPages.map(page => {
                console.log('maxCharactersByNetworkForText', page.network)
                const limit = maxCharactersByNetworkForText[page.network] ? maxCharactersByNetworkForText[page.network]({page}) : Infinity
                if (limit !== Infinity) {
                    maxCharactersByNetwork[page.network] = !maxCharactersByNetwork[page.network] ? limit : Math.min(limit, maxCharactersByNetwork[page.network])
                }
            })

            return Object.entries(maxCharactersByNetwork).map(([network,maxCharacters]) => (
                `<span>${network.charAt(0).toUpperCase() + network.slice(1)}: ${maxCharacters}`
            )).join('<br>')

        },

        // targetPages resout deja le perimetre affiché (toutes les pages sélectionnées / une seule
        // page / toutes les pages du réseau affiché) : en filtrant dessus, le formulaire général
        // agrege toutes les pages Facebook tandis qu'une personnalisation ne parle que d'elle-meme,
        // et rien ne s'affiche quand on personnalise un autre réseau.
        mentionsOverSafeLimitTargetPages() {
            return this.targetPages.filter(page => page && this.mentionsOverSafeLimitByPage[page.id])
        },

        // Le tooltip accepte du HTML (meme technique que le tooltip d'erreur par média plus haut)
        mentionsWarningTextContent() {
            const pages = this.mentionsOverSafeLimitTargetPages.filter(page => (
                this.mentionsOverSafeLimitByPage[page.id].count > maxMentionsSafeByNetwork.facebook
            ))

            if (!pages.length) return ''

            return [
                this.$t('dash.post-creator.form.mentions-warning.facebook', { max: maxMentionsSafeByNetwork.facebook }),
                `<b>${this.$t('dash.post-creator.form.mentions-warning.pages-affected')}</b>`,
                ...pages.map(page => `• ${page.name} (${this.mentionsOverSafeLimitByPage[page.id].count})`)
            ].join('<br>')
        },

        mentionsWarningComments() {
            const pages = this.mentionsOverSafeLimitTargetPages.filter(page => (
                this.mentionsOverSafeLimitByPage[page.id].comments.length
            ))

            if (!pages.length) return ''

            return [
                this.$t('dash.post-creator.form.mentions-warning.facebook', { max: maxMentionsSafeByNetwork.facebook }),
                `<b>${this.$t('dash.post-creator.form.mentions-warning.pages-affected')}</b>`,
                ...pages.map(page => {
                    const comments = this.mentionsOverSafeLimitByPage[page.id].comments.map(({index, count}) => (
                        `${this.$t('dash.post-creator.form.mentions-warning.comment', { index: index + 1 })} (${count})`
                    )).join(', ')

                    return `• ${page.name} — ${comments}`
                })
            ].join('<br>')
        }
    },

    watch: {
     
        ["formData.planifiedDate.date"]: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                if (!newValue || !newValue.length) {
                    this.formData.planifiedDate.hours = false
                    this.formData.planifiedDate.timestamp = false
                }

                this.checkValidDate()
            }
        },

        async ["formData.textContent"](newValue, oldValue) {
            console.log('watch formData textContent')
            this.formData.urlsTextContent = this.getUrlsContent(newValue)
            
            if (this.timeoutVerifMetaUrl) clearTimeout(this.timeoutVerifMetaUrl)

            this.timeoutVerifMetaUrl = setTimeout(async () => {
                console.log('watch formData textContent', this.formData.urlsTextContent)

                let urlsTextContentValid = []
                for (let url of this.formData.urlsTextContent) {
                    
                    try {
                        // urlsTextContentValid.push(url);
                        const res = await this.getNewsMeta(url);
                        const { success } = res.body;
                        console.log('watch formData textContent response',success)
                        if (success) {
                            urlsTextContentValid.push(url);
                        }
                    } catch (error) {
                        console.error('Echec de la récuperation des metas de l\'url.')
                    }
                }
                console.log('watch formData textContent test', urlsTextContentValid)
                this.formData.urlsTextContentHistory = [...new Set([...urlsTextContentValid, ...this.formData.urlsTextContentHistory])];
            },1000)
        },
        ["formData.files"](newValue, oldValue) {
            console.log('watch formData files')
            this.$emit('saveFormData')
        },
        networkSetting(value) {
            this.$emit('setSelectTypeRenderNetwork', value)
        },
        typeRenderNetworkSelected(value) {
            this.networkSetting = value
        }
        
    },

    beforeDestroy() { 
        EventBus.$off("eventCloseInput", this.resultInputMode) 
    }


    
}




</script>
